import Panel from './Panel'
import Heading from './Heading'
import Section from './Section'
import Footer from './Footer'

Panel.Heading = Heading
Panel.Section = Section
Panel.Footer = Footer

export default Panel

export { Heading, Section, Footer }
